<div class="container">
  <ul class="progressbar">
    <li *ngFor="let step of stepList" [class]="step.className">{{step.label}}</li>
  </ul>
</div>
